import { Injectable } from '@angular/core';
import {Router, NavigationEnd, RouterEvent} from '@angular/router';
import { filter } from 'rxjs/operators';
import {environment} from "../../environment/environment";

declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
  }
}

// Type guard helper
function isNavigationEnd(event: RouterEvent): event is NavigationEnd {
  return event instanceof NavigationEnd;
}

@Injectable({
  providedIn: 'root'
})
export class GoogleAnalyticsService {
  private measurementId = environment.gaMeasurementId;
  private debug = environment.gaDebug;


  constructor(private router: Router) {
    console.log("Starting Google Tag Manager");

    if (!this.measurementId) return;

    // Dynamically load GA script if not in debug mode
    //this.loadGAScript();

    // Track page views
    this.router.events.subscribe((event: any) => {
      if (isNavigationEnd(event)) {
        //this.trackPageView(event.urlAfterRedirects);
      }
    });
  }

  private loadGAScript(): void {
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${this.measurementId}`;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    window.gtag = (...args: any[]) => {
      window.dataLayer.push(args);
    };
    script.onload = () => {
      window.gtag('js', new Date());

      console.log("DEBUG VALUE: ", this.debug);

      window.gtag('config', this.measurementId, {
        debug_mode: this.debug
      });
    };
  }

  public trackPageView(path: string): void {
    if (this.debug) {
      console.log('[GA DEBUG] Page view:', path);
    }

    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
      event: 'page_view',
      page_path: path
    });
  }

  public event(eventName: string, params: Record<string, any>): void {
    if (this.debug) {
      console.log('[GA DEBUG] Event:', eventName, params);
    }

    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
      event: eventName,
      ...params
    });
  }
}
